// SentinelOne Singularity (DXL) datasource mappings.
// Each entry stores the complete prelude string in events[0].
// The emitter returns events[0] directly — no further field/value processing.
// Prelude format: event.category = '...' AND event.type = '...'
// Joined with joinWithAnd since the Singularity renderer has no finalize() hook.
import type { DatasourceMap } from '../datasource.types'

export const s1SingularityMap: DatasourceMap = {
  'SentinelOne Singularity': {
    any: {
      process_creation: {
        events: ["event.category = 'process' AND event.type = 'Process Creation'"],
      },
      file_event: {
        events: ["event.category = 'file' AND event.type = 'File Creation'"],
      },
      network_connection: {
        events: ["event.category = 'ip' AND event.type = 'IP Connect'"],
        unsupportedFields: ['domain'],
      },
      registry_event: {
        events: [
          "event.category = 'registry' AND (event.type = 'Registry Value Create' OR event.type = 'Registry Value Modified' OR event.type = 'Registry Key Create')",
        ],
      },
      image_load: {
        events: ["event.category = 'module' AND event.type = 'Module Load'"],
      },
      dns: {
        events: ["event.category = 'dns' AND event.type = 'DNS Resolved'"],
      },
      pipe_created: {
        events: ["event.category = 'named_pipe' AND event.type = 'Named Pipe Creation'"],
      },
      /* Unsupported event categories/types:
      authentication_events: {
        events: ["event.category = 'logins' AND event.type = 'Login'"],
      },
      firewall: {
        events: ["event.category = 'ip' AND event.type = 'IP Connect'"],
      },
      proxy: {
        events: ["event.category = 'url' AND (event.type = 'GET' OR event.type = 'POST')"],
      },
      cloud: {
        events: ["dataSource.name contains:anycase ('Azure', 'AWS', 'GCP')"],
      },
      application: {
        events: ["dataSource.name = 'Windows Event Logs'"],
      },
      security: {
        events: ["dataSource.name = 'Windows Event Logs'"],
      },
      system: {
        events: ["dataSource.name = 'Windows Event Logs'"],
      },
      */
    },
  },
}
